/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Socialnetworks_Socialnetwork_Label2Inputs */

const en_company_profile_socialnetworks_socialnetwork_label2 = /** @type {(inputs: Company_Profile_Socialnetworks_Socialnetwork_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const de_company_profile_socialnetworks_socialnetwork_label2 = /** @type {(inputs: Company_Profile_Socialnetworks_Socialnetwork_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform`)
};

/**
* | output |
* | --- |
* | "Platform" |
*
* @param {Company_Profile_Socialnetworks_Socialnetwork_Label2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_profile_socialnetworks_socialnetwork_label2 = /** @type {((inputs?: Company_Profile_Socialnetworks_Socialnetwork_Label2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Socialnetworks_Socialnetwork_Label2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_socialnetworks_socialnetwork_label2(inputs)
	return en_company_profile_socialnetworks_socialnetwork_label2(inputs)
});
export { company_profile_socialnetworks_socialnetwork_label2 as "company_profile_socialNetworks_socialNetwork_label" }